import { Record } from 'immutable';
import { PaymentStatus } from './payment-status.enum';
import { PaymentModifier } from './payment-modifier';

const PaymentRecord = Record({
  eventPaymentId: 0,
  commissionAmount: 0,
  feeAmount: 0,
  commissionCurrency: null,
  description: null,
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  status: null,
  createdDate: null,
  modifiedDate: null,
  createdBy: null,
  modifiedBy: null,
  eventId: 0,
  type: null,
  eventPaymentModifiers: null,
  actionReason: null,
  actionDetails: null,
  resendPaymentRequestAvailable: null
});

export class Payment extends PaymentRecord {
  eventPaymentId: number;
  commissionAmount: number;
  feeAmount: number;
  commissionCurrency: string;
  description: string;
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  status: PaymentStatus;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
  eventId: number;
  type: string;
  eventPaymentModifiers: PaymentModifier[];
  actionReason: string;
  actionDetails: string;
  resendPaymentRequestAvailable: boolean;
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/payment.ts